
import { ajax } from "@/plugins/ajax";

export default {
  namespaced: true,
  state: {
    list: []
  },
  getters: {
    list: state => state.list
  },
  actions: {
    fetch({ commit, dispatch }) {
        return ajax.get("Procurements/api/UnitOfMeasuresQuery/by-paging").then(r => {
          commit("setList", r.data.data);
          return r.data.data;
        });
      },
 
      fetchList({ commit, dispatch }, name) {
        return new Promise((resolve, reject) => {
          ajax
            .get("Procurements/api/UnitOfMeasuresQuery/search-on?name=" + name)
            .then(r => {
              resolve(r.data);
            })
            .catch(e => {
              reject(e);
            });
        });
      },
      createUnit({ commit, dispatch }, model) {
        return ajax.post("Procurements/api/UnitOfMeasures", model).then(() => {
          dispatch("fetch");
        });
      },
      editUnit({ commit, dispatch }, model) {
        return ajax.put("Procurements/api/UnitOfMeasures", model).then(() => {
          dispatch("fetch");
        });
      },
      deleteUnit({ commit, dispatch }, model) {
        return ajax.delete("Procurements/api/UnitOfMeasures", { data: { id: model } },).then(() => {
          dispatch("fetch");
        });
      },
  },
  mutations: {
    setList(state, data) {
      state.list = data;
    }
  }
};